module.exports = __webpack_public_path__ + "images/85cc2a32.img_chs_win_1.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/www/img_chs_win_1.jpg
// module id = 324
// module chunks = 0